import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, useQueryStates } from 'nuqs';

export function useAdminExamCenterLocationUsageListSearchParams() {
  const [{ page, pageSize }, setAdminExamCenterLocationUsageListSearchParams] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
  });

  const changePageNumber = (page: number) => {
    setAdminExamCenterLocationUsageListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setAdminExamCenterLocationUsageListSearchParams({ pageSize, page: 0 });
  };

  return [
    { page, pageSize },
    {
      changePageNumber,
      changePageSize,
    },
  ] as const;
}
